var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSlackNewLogo3 = function SvgSlackNewLogo3(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86632 0C4.98186 0.000652395 4.26606 0.716982 4.26671 1.59967C4.26606 2.48236 4.98251 3.19869 5.86697 3.19935H7.46723V1.60033C7.46789 0.717635 6.75143 0.00130479 5.86632 0C5.86697 0 5.86697 0 5.86632 0V0ZM5.86632 4.26667H1.60026C0.715805 4.26732 -0.000651915 4.98365 1.78648e-06 5.86634C-0.00130562 6.74903 0.715151 7.46536 1.59961 7.46667H5.86632C6.75078 7.46601 7.46723 6.74968 7.46658 5.86699C7.46723 4.98365 6.75078 4.26732 5.86632 4.26667Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0009 5.86634C16.0015 4.98365 15.285 4.26732 14.4006 4.26667C13.5161 4.26732 12.7996 4.98365 12.8003 5.86634V7.46667H14.4006C15.285 7.46601 16.0015 6.74968 16.0009 5.86634ZM11.7341 5.86634V1.59967C11.7347 0.717635 11.0189 0.00130479 10.1345 0C9.24999 0.000652395 8.53353 0.716982 8.53418 1.59967V5.86634C8.53287 6.74903 9.24934 7.46536 10.1338 7.46667C11.0183 7.46601 11.7347 6.74968 11.7341 5.86634Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1335 16C11.0179 15.9994 11.7344 15.283 11.7337 14.4003C11.7344 13.5176 11.0179 12.8013 10.1335 12.8007H8.5332V14.4003C8.53255 15.2824 9.24901 15.9987 10.1335 16ZM10.1335 11.7327H14.4002C15.2846 11.732 16.0011 11.0157 16.0004 10.133C16.0017 9.25032 15.2853 8.53399 14.4008 8.53268H10.1341C9.24966 8.53334 8.5332 9.24967 8.53386 10.1324C8.5332 11.0157 9.24901 11.732 10.1335 11.7327Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000977009 10.133C0.000323308 11.0157 0.71678 11.732 1.60124 11.7326C2.4857 11.732 3.20215 11.0157 3.2015 10.133V8.53326H1.60124C0.71678 8.53392 0.000323308 9.25025 0.000977009 10.133ZM4.26769 10.133V14.3997C4.26638 15.2824 4.98284 15.9987 5.86729 16C6.75175 15.9994 7.46821 15.283 7.46756 14.4003V10.1343C7.46886 9.25156 6.75241 8.53522 5.86795 8.53392C4.98284 8.53392 4.26703 9.25025 4.26769 10.133C4.26769 10.133 4.26769 10.1336 4.26769 10.133Z",
    fill: "#E01E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export default SvgSlackNewLogo3;